import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../auth/authContext';
import { PERMISSIONS } from '../auth/permissions';
import MetricsDashboard from './MetricsDashboard';

const Dashboard = () => {
  const { user, hasPermission } = useContext(AuthContext);

  // Si por alguna razón no hay usuario, redirige al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario puede ver métricas, muestra el panel de métricas
  if (hasPermission(PERMISSIONS.METRICS_VIEW)) {
    return <MetricsDashboard />;
  }

  // Si no, lo enviamos a la gestión de citas si tiene acceso
  if (hasPermission(PERMISSIONS.APPOINTMENTS_VIEW)) {
    return <Navigate to="/admin/appointments" replace />;
  }

  // Fallback por si no tiene acceso a ninguna sección
  return <div>No tienes permisos para ver esta sección.</div>;
};

export default Dashboard;
